export default __webpack_public_path__ + "static/media/Menu.1cd2c71d.jpg";